import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";
import { SERVICE_NAME } from "@zapier/utils";

export enum FolderActionInteractionOption {
  CreateFolder = "create_folder",
  CreateSubfolder = "create_subfolder",
  MoveFolder = "move_folder",
  CreateTable = "create_table",
  CreateInterface = "create_interface",
  CreateChatbot = "create_chatbot",
  CreateCanvas = "create_canvas",
  CreateAgent = "create_agent",
}

interface EmitOptions {
  optionSelected: FolderActionInteractionOption;
  interactionRawText?: string;
}

export function useEmitFolderActionEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    ({ optionSelected, interactionRawText }: EmitOptions) => {
      emitUserInteractionEvent({
        accountId,
        eventAction: "click",
        interactionName: UserInteractionName.FolderAction,
        interactionRawText,
        optionSelected,
        systemName: SERVICE_NAME,
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
